/***********
 * 承诺意见
 **************/
import LaborDetailTitleValue from "./LaborDetailTitleValue.vue";
export default {
  components: {
    LaborDetailTitleValue
  },
  props: {
    laboratoryItemDetail: {
      type: Object
    },
    moudleName: {
      type: String
    }
  },

  data() {
    return {};
  }

};